module.exports = __webpack_public_path__ + "static/media/photography01.910af2fd.png";